import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message, Input, Uploader } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import InfoReportsAudit from './InfoReportsAudit'
import ReportsAuditForm from './ReportsAuditForm'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG, SAVE_FAILED_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { sessionRemoveItem } from '../../../utils/sessionHelpers'
import { useHistory } from 'react-router-dom'
import { downloadFile, previewFile } from '../../../utils/fileUtil'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import { convertDataReportAudit } from './AuditConvertDataUtil'
import {
  saveReportsAudit,
  saveReportsAuditReviewPass,
  sendBackReportsAudit,
} from '../../../redux/actions/reportsAudit'
import pathname from '../../../constants/pathname'
import EditButton from '../../../components/buttons/editButton/EditButton'
import { isEmpty } from 'lodash-es'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import ViewButton from '../../../components/buttons/viewButton/ViewButton'
import { downloadAuditIAp12Pdf } from '../../../redux/actions/auditReportSummary'
import { isSupportFileType } from '../../../utils/ValidatorUtils'
import classNames from 'classnames'
import AppContext from '../../../context/AppContext'
import ReportsAuditIAP12Widget from './ReportsAuditIAP12Widget'

export default function ReportsAuditWidget(props) {
  const { theme } = React.useContext(AppContext)
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [request, setRequest] = useState()
  const [isEnableEdit, setIsEnableEdit] = useState()
  const [requestBody, setRequestBody] = useState()
  const [requestPassBody, setRequestPassBody] = useState()
  // const projectCode = sessionGetItemStr('projectCode')
  // const subProjectCode = sessionGetItemStr('subProjectCode')
  // const { periodNo } = sessionGetItemObj('subProjectPeriodInfo')
  // const subIncomeId = sessionGetItemStr('subIncomeId')
  // const isViewOnly = !!sessionGetItemStr('isViewOnly')
  const [isShowConfimModal, setIsShowConfimModal] = useState(false)
  const [isShowSendBack, setIsShowSendBack] = useState(false)
  const [isSaveDraft, setIsSaveDraft] = useState(false)

  const [isShowReviewPassConfimModal, setIsShowReviewPassConfimModal] = useState(false)

  const [sendbackNote, setSendbackNote] = useState()
  const [commentFile, setCommentFile] = useState()

  const [sendBackText, setsendBackText] = useState()

  const [isRefash, setIsRefash] = useState(false)

  let history = useHistory()

  const onSubmit = (data) => {
    // console.log('onSubmit => ', data)

    const request = convertDataReportAudit(data, formSchema?.form?.id)

    // if (formSchema.auditRole.isAuditor2) {
    //   request.grade = 0
    // }

    if (request) {
      // console.log('request', request)

      setIsSaveDraft(false)
      setIsShowConfimModal(true)
      setRequestBody(request)
    }
  }

  const onSubmitDraft = () => {
    console.log('onSubmitDraft')

    var data = {}
    //clear error all input
    for (const key in getValues()) {
      Object.assign(data, { [`${key}`]: getValues(key) })
      clearErrors(key)
    }

    const request = convertDataReportAudit(data, formSchema?.form?.id)

    // if (formSchema.auditRole.isAuditor || formSchema.auditRole.isAuditor2) {
    //   request.grade = 0
    // }
    // console.log('requestชชชฬ', request)
    if (request) {
      setIsSaveDraft(true)
      setIsShowConfimModal(true)
      setRequestBody(request)
    }
  }

  const handleSaveAllConfirmModal = async () => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await saveReportsAudit(requestBody, formSchema?.form?.id, isSaveDraft)
      console.log('response ', response)
      if (response) {
        setFormSchema(response.model)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setRequestBody()
        setIsShowConfimModal(false)
        onRefash()
      } else {
        setIsError()
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
      })
      setIsError(e?.response?.data?.errorMessage)
      setIsShowConfimModal(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleSaveReviewPass = async () => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await saveReportsAuditReviewPass({ id: formSchema?.form?.id })
      console.log('response ', response)
      if (response) {
        setFormSchema(response.model)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        // setRequestPassBody()
        setIsShowReviewPassConfimModal(false)
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
        })
      }
    } catch (e) {
      console.log('error', e)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
      })

      setIsShowReviewPassConfimModal(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleOnSubmitDraftOne = () => {
    // console.log('handleOnSubmitDraftOne ', data)

    onSubmitDraft()
  }

  const handleCancel = () => {
    // console.log('handleCancel')
    sessionRemoveItem('auditInfo')

    history.push(`${pathname.audit.AuditReportSummary}`)
  }

  const handleSendBack = async (request) => {
    startLoading()
    setIsLoading(true)
    try {
      let response = await sendBackReportsAudit(request, formSchema?.form?.id)
      console.log('response ', response)
      if (response?.model) {
        setFormSchema(response.model)

        notification.open('success', {
          title: SAVE_SUCCESS_MSG,
        })
        setSendbackNote('')
        setIsShowSendBack(false)

        onRefash()
      } else {
        notification.open('error', {
          title: SAVE_FAILED_MSG,
        })
      }
    } catch (e) {
      // console.log('error', e)
      notification.open('error', {
        title: SAVE_FAILED_MSG,
      })
      // setIsError(e?.response?.data?.errorMessage)
      setIsShowSendBack(false)
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSendBack = () => {
    // var request = {
    //   id : formSchema?.form?.id,
    //   note: sendbackNote,
    // }

    const formData = new FormData()
    formData.append('Id', formSchema?.form?.id || '')
    formData.append('Note', sendbackNote || '')

    if ((commentFile?.length || 0) == 1) {
      formData.append('File', commentFile[0]?.blobFile)
    }

    handleSendBack(formData)
  }

  const handleDownloadIAp12 = async (filePath, type) => {
    // console.log('data => ', data.filePathIAp12)

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadAuditIAp12Pdf(filePath)
      // console.log('file', file)
      if (file) {
        if (type == 'view') {
          previewFile(file, `IAp12_${formSchema?.projectInfo.projectCode}`)
        } else {
          downloadFile(file, `IAp12_${formSchema?.projectInfo.projectCode}`)
        }
      } else {
        notification.open('error', {
          title: DEFAULT_ERR_MSG,
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleDownloadIAp12 error : ', e)
      notification.open('error', {
        title: e?.response?.data?.errorMessage || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  const onRefash = () => {
    setIsRefash(true)
    setTimeout(() => {
      setIsRefash(false)
    }, 50)
  }

  return (
    <>
      <Panel shaded collapsible defaultExpanded header={''} bordered>
        {isLoading && <OverlayLoader />}

        {!isRefash && (
          <>
            <InfoReportsAudit
              schema={formSchema?.projectInfo}
              auditorRole={formSchema.auditRole.isAuditor || formSchema.auditRole.isAuditor2}
            />

            {formSchema?.form && (
              <>
                <ReportsAuditForm
                  schema={formSchema?.form}
                  auditRole={formSchema?.auditRole}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  getValues={getValues}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  setIsEnableEdit={setIsEnableEdit}
                  onSubmitDraftOne={handleOnSubmitDraftOne}
                  disabled={formSchema?.disabled}
                />

                {formSchema.form.isIAp12AttachSchema && (
                  <ReportsAuditIAP12Widget
                    shaded={false}
                    auditId={formSchema.form.id}
                    style={{ marginTop: 10 }}
                  />
                )}

                <Row style={{ marginTop: 20 }}>
                  <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    {formSchema?.form?.iAp12Path && (
                      <ViewButton
                        style={{ marginRight: 5 }}
                        onClick={() => {
                          handleDownloadIAp12(formSchema.form.iAp12Path)
                        }}
                        icon="download"
                      >
                        โหลด IAp 12
                      </ViewButton>
                    )}

                    {formSchema?.form?.button?.saveButton && (
                      <SaveButton
                        style={{ marginRight: 5 }}
                        // onClick={handleSubmit(onSubmitDraft)}
                        onClick={() => {
                          onSubmitDraft()
                        }}
                        disabled={formSchema?.disabled}
                      >
                        {formSchema?.form?.button?.saveButton}
                      </SaveButton>
                    )}

                    {formSchema?.form?.button?.submitButton && (
                      <SaveButton
                        onClick={handleSubmit(onSubmit)}
                        style={{ marginRight: 5 }}
                        disabled={formSchema?.disabled}
                      >
                        {formSchema?.form?.button?.submitButton}
                      </SaveButton>
                    )}

                    {formSchema?.form?.button?.reviewPassButton && (
                      <SaveButton
                        style={{
                          marginRight: 5,
                        }}
                        icon="check-circle"
                        onClick={() => {
                          setIsShowReviewPassConfimModal(true)
                        }}
                        children={formSchema.form.button.reviewPassButton}
                      />
                    )}

                    {formSchema?.form?.button?.reviewButton && (
                      <EditButton
                        style={{
                          marginRight: 5,
                        }}
                        // icon="reply"
                        onClick={() => {
                          setsendBackText(formSchema.form.button.reviewButton)
                          setIsShowSendBack(true)
                        }}
                        children={formSchema.form.button.reviewButton}
                      />
                    )}

                    {formSchema?.form?.button?.sendbackButton && (
                      <EditButton
                        style={{
                          marginRight: 5,
                        }}
                        icon="reply"
                        onClick={() => {
                          setsendBackText(formSchema.form.button.sendbackButton)
                          setIsShowSendBack(true)
                        }}
                        children={formSchema.form.button.sendbackButton}
                      />
                    )}

                    {formSchema?.form?.button?.cancelButton && (
                      <CancelButton
                        style={{ marginTop: 0 }}
                        onClick={() => {
                          handleCancel()
                        }}
                      >
                        {formSchema?.form?.button?.cancelButton || 'ยกเลิก'}
                      </CancelButton>
                    )}
                  </Col>
                </Row>
              </>
            )}
          </>
        )}
      </Panel>

      <Modal
        backdrop="static"
        size="md"
        show={isShowSendBack}
        onHide={() => {
          setSendbackNote('')
          setsendBackText('')
          setCommentFile([])
          setIsShowSendBack(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>
            <p style={{ paddingTop: '0.5rem' }}>ยืนยัน{sendBackText}</p>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div style={{ marginTop: 10, marginLeft: 5, marginRight: 5 }}>
            <label className={'required'}>ความเห็น</label>
            <Input
              name="sendbackNote"
              placeholder="ระบุความเห็น จำนวนอักขระไม่เกิน 1,000 อักขระ"
              value={sendbackNote}
              rows={4}
              componentClass="textarea"
              maxLength={1000}
              onChange={(value) => {
                setSendbackNote(value)
              }}
            />
            <ShowLimitLength textLength={sendbackNote?.length || 0} maxLength={1000} />
          </div>

          {formSchema?.form?.iAp12ReviewAttach && (
            <Uploader
              accept={'.docx, .pdf'}
              autoUpload={false}
              fileListVisible={true}
              listType="picture-text"
              fileList={commentFile || []}
              onChange={(fileList) => {
                if (isEmpty(fileList)) {
                  // props.onChange(undefined)
                  setCommentFile([])
                } else {
                  let file = fileList[fileList.length - 1]

                  if (!isSupportFileType(file.blobFile.type, '.docx, .pdf')) {
                    notification.open('error', {
                      title: 'ชนิดที่รองรับ ' + '.docx, .pdf',
                      duration: 5000,
                    })
                    return
                  } else if (file.blobFile.size > 30 * 1024 * 1024) {
                    notification.open('error', {
                      title: `ขนาดไฟล์เกิน ${30} MB`,
                      duration: 5000,
                    })
                    return
                  }
                  setCommentFile([file])
                }
              }}
              draggable
            >
              <div>
                <div
                  style={{ lineHeight: '30px' }}
                  className={classNames('uploader', `${theme[0]}-background`)}
                >
                  <Icon size="3x" icon="upload2" />
                  <small className="uploder__text">
                    <p
                      style={{ wordBreak: 'break-word' }}
                      dangerouslySetInnerHTML={{
                        __html: `คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด ชนิดที่รองรับ : .docx, .pdf <b>ขนาดไม่เกิน ${30} Mb</b>`,
                      }}
                    />
                  </small>
                </div>
              </div>
            </Uploader>
          )}
        </Modal.Body>

        <Modal.Footer>
          <div>
            <SaveButton
              onClick={onSendBack}
              loading={isLoading}
              disabled={
                isEmpty(sendbackNote) ||
                (formSchema?.form?.iAp12ReviewAttach &&
                  !formSchema?.form?.isIgnoreIAp12ReviewAttach &&
                  (commentFile?.length || 0) < 1)
              }
            >
              ยืนยัน
            </SaveButton>
            <CancelButton
              onClick={() => {
                setSendbackNote('')
                setsendBackText('')
                setCommentFile([])
                setIsShowSendBack(false)
              }}
            >
              ยกเลิก
            </CancelButton>
          </div>
        </Modal.Footer>
      </Modal>

      <ConfirmWidget
        title={`ยืนยันการ${isSaveDraft ? 'บันทึกร่าง' : formSchema.buttonText || 'บันทึก'}`}
        show={isShowConfimModal}
        onCancle={() => {
          setIsShowConfimModal(false)
        }}
        onConfirm={handleSaveAllConfirmModal}
      />

      <ConfirmWidget
        //title={`ยืนยันการ${formSchema.form.button.reviewPassButton}`}
        show={isShowReviewPassConfimModal}
        detail={`ยืนยันการ${formSchema.form.button.reviewPassButton}`}
        onCancle={() => {
          setIsShowReviewPassConfimModal(false)
        }}
        onConfirm={handleSaveReviewPass}
      />
    </>
  )
}
